import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getErrors({ commit }) {
        return axios
            .get('/complaints/complaints/complaint-errors')
            .then(response => {
                commit('GET_COMPLAINT_ERROR_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie błędów nie powiodło się.')

                return Promise.reject(error)
            })
    },
}
